import React from 'react';

import { isEmpty } from 'lodash';
import {
  faClock,
  faNotes,
  faUsers,
} from '@awesome.me/kit-a6e51d954f/icons/classic/regular';

import { appointmentShape } from '../../../../types';
import { formatDateTimeRange } from '../../../../utils';
import InfoSection from './InfoSection';

const AppointmentInfo = ({ activeAppointment }) => {
  const attendeeNames = activeAppointment.users.map((user) => user.fullName).join(', ');

  const dateTimeRange = formatDateTimeRange({
    startAt: activeAppointment.startAt,
    endAt: activeAppointment.endAt,
  });

  return (
    <>
      <InfoSection icon={faClock} label="Date & Time">
        {dateTimeRange}
      </InfoSection>

      {!isEmpty(activeAppointment.description) && (
        <InfoSection icon={faNotes} label="Notes">
          {activeAppointment.description}
        </InfoSection>
      )}

      <InfoSection icon={faUsers} label="Attendees">
        {attendeeNames}
      </InfoSection>
    </>
  );
};

AppointmentInfo.propTypes = {
  activeAppointment: appointmentShape.isRequired,
};

export default AppointmentInfo;
